import type { CmmdOrgProviderPolicy, ProviderKind, ServerProvider } from "@cmmd-forge/contracts";

import { ProviderModelPicker } from "~/components/chat/ProviderModelPicker";
import type { ModelPickerProviderAvailability } from "~/components/chat/modelPickerProviderAvailability";

interface AutomationModelPickerFieldProps {
  readonly model: string;
  readonly modelOptionsByProvider: Record<
    ProviderKind,
    ReadonlyArray<{ slug: string; name: string }>
  >;
  readonly orgProviderPolicy: CmmdOrgProviderPolicy | null;
  readonly projectSelected: boolean;
  readonly provider: ProviderKind;
  readonly providers: readonly ServerProvider[];
  /** Why the picker may withhold each provider it shows, per `ProviderModelPicker`. */
  readonly providerAvailability: ReadonlyArray<ModelPickerProviderAvailability>;
  readonly statusText: string;
  readonly onChange: (provider: ProviderKind, model: string) => void;
}

export function AutomationModelPickerField(props: AutomationModelPickerFieldProps) {
  return (
    <section aria-labelledby="automation-model-heading">
      <h2 id="automation-model-heading" className="text-sm font-semibold">
        Model
      </h2>
      <div className="mt-3">
        <ProviderModelPicker
          lockedProvider={null}
          model={props.model}
          modelOptionsByProvider={props.modelOptionsByProvider}
          orgProviderPolicy={props.orgProviderPolicy}
          provider={props.provider}
          providers={props.providers}
          providerAvailability={props.providerAvailability}
          projectSelected={props.projectSelected}
          triggerClassName="border border-input bg-background"
          triggerVariant="outline"
          onProviderModelChange={props.onChange}
        />
        <p className="mt-2 text-sm text-muted-foreground md:text-xs">{props.statusText}</p>
      </div>
    </section>
  );
}
